import { ValidationResult } from '../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';

// validate rule scope selection group
export function validateTargetScanObjectGroup(values: boolean[]): ValidationResult {
  if (!values.includes(true)) {
    return {
      valid: false,
      error: translateFn('Select at least one object type.'),
    };
  }

  return { valid: true };
}
